export const jobInfo = {
  title: "Software Engineer",
  company: "Weill Cornell Medicine"
}

export const skillsList = [
  'Servicios a Hoteles y Empresas',
  'Planchado',
  'Secado',
  'Desmanchado',
  'Lavado',
  'Costura y arreglos en general',
]

export const projects = [
  {
    title: 'Hoteles',
    description: 'Hemos ofrecido nuestros servicios a destacados hoteles de diversas zonas de Caracas durante más de 30 años, destacando nuestro compromiso y eficiencia en cuanto a la lencería en el área de hostelería.',
    image:
      'https://cf.bstatic.com/xdata/images/hotel/max1024x768/388197712.jpg?k=5d267c51b4bcb54222cdb0def43c8e44cc1d7f4ad1de3615e6c81ab8d2fc3a08&o=&hp=1',
    link: '',
  },
  {
    title: 'Clubs',
    description:
      'A lo largo de nuestra historia hemos sido los principales responsables de la lavandería de emblemáticos clubs de Caracas, incluyendo servicios para personal y locales.',
    image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRoqOhTsNKqnJzaJKEImgLWmiy6OnqFWuxqIjLekqY1MRfQB3cQmcxw04_r1Oqov0cnQ5U&usqp=CAU',
    link: '',
  },
  {
    title: 'Restaurantes',
    description:
      'Super Hollywood se ha encargado de la lavandería de diversas áreas, y los restaurantes no han sido excepción. Durante años hemos sido eficientes en desmanchado, lavado, secado y planchado de uniformes y manteles de nuestros clientes. ',
    image:
      'https://www.cursosgastronomia.com.mx/wp-content/uploads/2014/05/caracteristicas-de-restaurante-exitoso.JPG',
    link: '',
  },
  {
    title: 'Particulares',
    description:
      'No solo operamos a gran escala, por mucho tiempo hemos garantizado los más competitivos y asequibles servicios de lavado, secado y planchado a particulares en todo el mercado, incluyendo servicios para cubrecamas, alfombras, sábanas, trajes, hamacas, etc.',
    image:
      'https://img.freepik.com/foto-gratis/grupo-personas-trabajando-plan-negocios-oficina_1303-15874.jpg',
    link: '',
  }
]



export const galeria = [
  {
    title: 'Historia',
    description: 'Surgimos como lavandería en 1954 en la Avenida Francisco de Miranda, contando con una amplia tradición caraqueña.',
    image:
      'https://2.bp.blogspot.com/-zrWo7BDd9_g/UCgFHOG2C4I/AAAAAAAARWc/UdAaT4eiEf8/s1600/Tintorer%25C3%25ADa+S%25C3%25BAper+Hollywood+-+Chacao+%25281%2529.jpg',
    link: '',
  },
  {
    title: 'Actualidad',
    description:
      'Hoy en día contamos con los mejores equipos para garantizar lo mejor en lavandería.',
    image: 'https://media.istockphoto.com/id/1399923029/es/foto/autoservicio-de-lavander%C3%ADa-autom%C3%A1tica-lavander%C3%ADa.jpg?s=612x612&w=0&k=20&c=kX0z_sanoSaGccSCv7TsireieRRsYu-ydDHqStmmmRc= ',
    link: '',
  },
]



export const galeria2 = [
  {
    title: 'Historia',
    description: 'Surgimos como lavandería en 1954 en la Avenida Francisco de Miranda, contando con una amplia tradición caraqueña.',
    image:
      'https://2.bp.blogspot.com/-zrWo7BDd9_g/UCgFHOG2C4I/AAAAAAAARWc/UdAaT4eiEf8/s1600/Tintorer%25C3%25ADa+S%25C3%25BAper+Hollywood+-+Chacao+%25281%2529.jpg',
    link: '',
  },
  {
    title: 'Actualidad',
    description:
      'Hoy en día contamos con los mejores equipos para garantizar lo mejor en lavandería.',
    image: 'https://media.istockphoto.com/id/1399923029/es/foto/autoservicio-de-lavander%C3%ADa-autom%C3%A1tica-lavander%C3%ADa.jpg?s=612x612&w=0&k=20&c=kX0z_sanoSaGccSCv7TsireieRRsYu-ydDHqStmmmRc= ',
    link: '',
  },
]

export const skillsList2 = [
  '02122661158',
  '04143250363',

]